export default {
  gift_giving: {
    index_page: {
      give_count: '{0} 张'
    },
    detail_page: {
      orders: '适用订单',
      stations: '适用电站',
      rules: '规则说明',
      all_order: '所有订单',
      order_condition: '订单满 {0} 元',
      station_condition: '{0}的所有充电站',
      expired: '过期',
      discount_stacking_type: '优惠叠加类型'
    }
  }
}
